import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const SnackbarError = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ height: '16px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_6493_180)">
        <path
          d="M7.99975 6.00015V8.66682M7.99975 11.3335H8.00642M7.07663 2.59464L1.59338 12.0657C1.28924 12.591 1.13717 12.8537 1.15965 13.0693C1.17925 13.2573 1.27776 13.4282 1.43067 13.5394C1.60597 13.6668 1.90948 13.6668 2.5165 13.6668H13.483C14.09 13.6668 14.3935 13.6668 14.5688 13.5394C14.7217 13.4282 14.8203 13.2573 14.8399 13.0693C14.8623 12.8537 14.7103 12.591 14.4061 12.0657L8.92288 2.59463C8.61983 2.07119 8.46831 1.80947 8.27062 1.72157C8.09818 1.64489 7.90133 1.64489 7.72889 1.72157C7.5312 1.80947 7.37968 2.07119 7.07663 2.59464Z"
          stroke="#FF5F57"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6493_180">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default SnackbarError;
